import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAqH1Wkfm6DUdNdLEk0DRmDUxU_zUbEHWA",
  authDomain: "chat-app-1840f.firebaseapp.com",
  projectId: "chat-app-1840f",
  storageBucket: "chat-app-1840f.appspot.com",
  messagingSenderId: "15065525872",
  appId: "1:15065525872:web:b4d4cbb4ae0d38e183ceb5",
  measurementId: "G-DLRH1E8VX4"
})

const db = firebaseApp.firestore()
const auth = firebase.auth()

export { db, auth }
export const register = async ({ email, password }) => {
  auth.createUserWithEmailAndPassword(email, password)
    .then((userCredential) => {
      // send verification mail.
      userCredential.user.sendEmailVerification();
      auth.signOut();
      alert("Verification Email Sent");
    })
    .catch(alert);

}


export const login = async ({ email, password }) => {
  const res = await firebase.auth()
    .signInWithEmailAndPassword(email, password)
    .catch(alert);
  if (res) {
    return res.user;
  }

}
export const provider2 = new firebase.auth.TwitterAuthProvider();
